module.exports = __webpack_public_path__ + "img/a-table-icon.533210e8.svg";